export const GET_TRANSIT_RECORD = "GET_TRANSIT_RECORD";
export const SET_TRANSIT_RECORD_PDF_STATUS = "SET_TRANSIT_RECORD_PDF_STATUS";

export const SET_TRANSIT_RECORD_INDEX = "SET_TRANSIT_RECORD_INDEX";
export const CLEAR_TRANSIT_RECORD_INDEX = "CLEAR_TRANSIT_RECORD_INDEX";

export const SET_SELECTED_TSID = "SET_SELECTED_TSID";
export const CLEAR_SELECTED_TSID = "CLEAR_SELECTED_TSID";